export const BILLING_CONFIG: object = {
  sectionName: "billing",
  id: "CL001.29",
  cards: [
    {
      cardName: "newPatientSnfAlf",
      id: "CL010.273",
      componentId: "newPatientSnfAlf",
      type: "palliativeCard",
      access: "write",
      required: true,
      sortOrder: 1,
      data: {
        dataHeaders: [
          {
            fieldName: "snf",
            size: "2",
          },
          {
            fieldName: "hpi",
            size: "2",
          },
          {
            fieldName: "ros",
            size: "2",
          },
          {
            fieldName: "exam",
            size: "2",
          },
          {
            fieldName: "history",
            size: "2",
          },
          {
            fieldName: "time",
            size: "1",
          },
        ],
      },
      billingCodes: [
        {
          row: [
            {
              fieldName: "99324",
              size: "2",
            },
            {
              fieldName: "BRIEF_TITLE",
              size: "2",
            },
            {
              fieldName: "na",
              size: "2",
            },
            {
              fieldName: "affectedOrganSystemOnly",
              size: "2",
            },
            {
              fieldName: "problemFocused",
              size: "2",
            },
            {
              fieldName: "twentyMinutes",
              size: "1",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "99325",
              size: "2",
            },
            {
              fieldName: "BRIEF_TITLE",
              size: "2",
            },
            {
              fieldName: "oneSystem",
              size: "2",
            },
            {
              fieldName: "organSystemSymptomAreas",
              size: "2",
            },
            {
              fieldName: "problemFocusedPlus",
              size: "2",
            },
            {
              fieldName: "thirtyMinutes",
              size: "1",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "99326",
              size: "2",
            },
            {
              fieldName: "fourElements",
              size: "2",
            },
            {
              fieldName: "twoNineSystems",
              size: "2",
            },
            {
              fieldName: "twoSevenSystems",
              size: "2",
            },
            {
              fieldName: "detailed",
              size: "2",
            },
            {
              fieldName: "fourtyFiveMintues",
              size: "1",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "99327",
              size: "2",
            },
            {
              fieldName: "fourElements",
              size: "2",
            },
            {
              fieldName: "tenPlusSystems",
              size: "2",
            },
            {
              fieldName: "multiSystem",
              size: "2",
            },
            {
              fieldName: "comprehensive",
              size: "2",
            },
            {
              fieldName: "sixtyMinutes",
              size: "1",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "99328",
              size: "2",
            },
            {
              fieldName: "fourElements",
              size: "2",
            },
            {
              fieldName: "tenPlusSystems",
              size: "2",
            },
            {
              fieldName: "multiSystem",
              size: "2",
            },
            {
              fieldName: "comprehensive",
              size: "2",
            },
            {
              fieldName: "seventyFiveMinutes",
              size: "1",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "na",
              size: "11",
            },
          ],
        },
      ],
    },
    {
      cardName: "advancedCarePlanning",
      id: "CL010.274",
      componentId: "advancedCarePlanning",
      type: "palliativeCard",
      access: "write",
      sortOrder: 1,
      data: {},
      billingCodes: [
        {
          row: [
            {
              fieldName: "99497",
              size: "2",
            },
            {
              fieldName: "firstThirtyMinutes",
              size: "2",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "plus99498",
              size: "2",
            },
            {
              fieldName: "eachAdditionalThirtyMinutes",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "na",
              size: "2",
            },
          ],
        },
        {
          additionalText: [
            {
              text: "indicatesAddOnCode",
            },
          ],
        },
      ],
    },
    {
      cardName: "prolongedEvaluationManagement",
      id: "CL010.275",
      componentId: "prolongedEvaluationManagement",
      type: "palliativeCard",
      access: "write",
      sortOrder: 1,
      data: {},
      billingCodes: [
        {
          row: [
            {
              fieldName: "99354",
              size: "2",
            },
            {
              fieldName: "firstSixtyMinutes",
              size: "2",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "99355",
              size: "2",
            },
            {
              fieldName: "eachAdditionalThirtyMinutes",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "na",
              size: "2",
            },
          ],
        },
      ],
    },
    {
      cardName: "smokingCessation",
      id: "CL010.276",
      componentId: "smokingCessation",
      type: "palliativeCard",
      access: "write",
      sortOrder: 1,
      data: {},
      billingCodes: [
        {
          row: [
            {
              fieldName: "99406",
              size: "2",
            },
            {
              fieldName: "threeTenMinutes",
              size: "2",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "99407",
              size: "2",
            },
            {
              fieldName: ">10 minutes",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "na",
              size: "2",
            },
          ],
        },
      ],
    },
    {
      cardName: "medicareAnnualWellnessExamn",
      id: "CL010.277",
      componentId: "medicareAnnualWellnessExamn",
      type: "palliativeCard",
      access: "write",
      sortOrder: 1,
      data: {},
      billingCodes: [
        {
          row: [
            {
              fieldName: "G0402",
              size: "2",
            },
            {
              fieldName: "initialPreventativePhysicalExam",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "G0348",
              size: "2",
            },
            {
              fieldName: "annualWellnessVisitInitial",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "G0349",
              size: "2",
            },
            {
              fieldName: "annualWellnessVisitSub",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "na",
              size: "2",
            },
          ],
        },
      ],
    },
    {
      cardName: "chronicCareManagementStar",
      id: "CL010.278",
      componentId: "chronicCareManagementStar",
      type: "palliativeCard",
      access: "write",
      sortOrder: 1,
      data: {
        dataHeaders: [
          {
            fieldName: "singleCodeBilledBySingleProvider",
            size: "3",
          },
          {
            fieldName: "TotalMinutesPerMonth",
            size: "3",
          },
        ],
      },
      billingCodes: [
        {
          row: [
            {
              fieldName: "99490",
              size: "3",
            },
            {
              fieldName: "twentyFiftyNineMinutes",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "99487",
              size: "3",
            },
            {
              fieldName: "sixtyEightyNineMinutes",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "plus99489",
              size: "3",
            },
            {
              fieldName: "eachAdditionalThirtyMinutes",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "plusG0506",
              size: "3",
            },
            {
              fieldName: "comprehensiveAssessmentAndCarePlanning",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "na",
              size: "2",
            },
          ],
        },
        {
          additionalText: [
            {
              text: "nonFaceToFaceCareCoordination",
            },
            {
              text: "indicatesAddOnCode",
            },
          ],
        },
      ],
    },
    {
      cardName: "transitionalCareManagement",
      id: "CL010.279",
      componentId: "transitionalCareManagement",
      type: "palliativeCard",
      access: "write",
      sortOrder: 1,
      data: {
        dataHeaders: [
          {
            fieldName: "faceTofaceVisitWithinSevenDays",
            size: "3",
          },
          {
            fieldName: "faceTofaceVisitWithinEightFourteenDays",
            size: "3",
          },
          {
            fieldName: "complexity",
            size: "2",
          },
        ],
      },
      billingCodes: [
        {
          row: [
            {
              fieldName: "99495",
              size: "3",
            },
            {
              fieldName: "99495",
              size: "3",
            },
            {
              fieldName: "moderate",
              size: "2",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "99496",
              size: "3",
            },
            {
              fieldName: "99495",
              size: "3",
            },
            {
              fieldName: "high",
              size: "2",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "na",
              size: "2",
            },
          ],
        },
        {
          additionalText: [
            {
              text: "mustBeAccompaniedByClinicalPhoneCall",
            },
          ],
        },
      ],
    },
    {
      cardName: "cognitiveImpairmentAssessmentAndCarePlanning",
      id: "CL010.280",
      componentId: "cognitiveImpairmentAssessmentAndCarePlanning",
      type: "palliativeCard",
      access: "write",
      sortOrder: 1,
      data: {},
      billingCodes: [
        {
          row: [
            {
              fieldName: "99483",
              size: "2",
            },
            {
              fieldName: "cognitionAndFunctionalAssessment",
              size: "3",
            },
          ],
        },
        {
          row: [
            {
              fieldName: "na",
              size: "2",
            },
          ],
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/mocks/sections/mock-billing-config.ts